import { constants } from "@layout";
import styled from "styled-components";

export const Container = styled.div`
  margin-right: ${constants.divPadding}px;
  width: 60px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

export const Placeholder = styled.div`
  margin-right: ${constants.divPadding}px;
  width: 60px;
`;
